const search = {
  state: {
    currentSearch: {
      title_content: '', // 内容+标题
      title: '', // 仅标题
      people: '', // 涉稿人名
      organization: '', // 涉稿机构
      address: '', // 涉稿地址
      time: '', // 更新时间
      department: '', // 发稿部门
      type: '', // 稿件类型
      label: '', // 预定义标签
      property: '', // 稿件属性
      column: '', // 栏目
      sort: 'desc', // 排序
      tag: '', // 标签
      uid: '', // 角色id
      ctime: '', // 创建时间
      folder: '',
      from: 0,
      size: 10,
      table: 1,
      field: '' // 表格表头
    },
    normalCurrentSearch: {
      title_content: '',
      title: '',
      people: '',
      organization: '',
      address: '',
      time: '',
      department: '',
      type: '',
      label: '',
      property: '',
      column: '',
      sort: 'desc',
      ctime: '', // 创建时间
      tag: '',
      uid: '',
      folder: '',
      from: 0,
      size: 10,
      table: 1,
      field: ''
    },
    listInfo: {
      listSort: 'desc',
      listType: 1,
      listTotal: 0,
      currentPage: 1,
      searchAuthority: true
    },
    allField: [],
  },
  mutations: {
    SET_CURRENT_SEARCH: (state, obj) => {
      state.currentSearch = obj
    },
    SET_LIST_SORT: (state, value) => {
      state.listInfo.listSort = value
      state.currentSearch.sort = value
    },
    SET_LIST_TYPE: (state, value) => {
      state.listInfo.listType = value
      state.currentSearch.table = value
    },
    SET_LIST_TOTAL: (state, value) => {
      state.listInfo.listTotal = value
    },
    SET_CURRENT_PAGE: (state, value) => {
      state.listInfo.currentPage = value
    },
    SET_ALL_FIELD: (state, arr) => {
      state.allField = arr
    },
    ADD_CHECK_FIELD: (state, value) => {
      state.allField[value].check = true
    },
    DELETE_CHECK_FIELD: (state, value) => {
      state.allField[value].check = false
    },
    SET_NORMAL_CURRENT: (state) => {
      state.currentSearch = {
        ...state.normalCurrentSearch,
        table: state.currentSearch.table,
        field: state.currentSearch.field,
        sort: state.currentSearch.sort
      }
      state.listInfo = {
        ...state.listInfo,
        listTotal: 0,
        currentPage: 1
      }
    },
    SET_SEARCH_AUTHORITY: (state, value) => {
      state.listInfo.searchAuthority = value
    }
  }
}

export default search